import HintImage from '../../assets/images/hint-rotate-device.svg';
import './HintOverlay.scss';

const TEXT_HINT = 'Please switch a phone to the landscape mode';

export default function HintOverlay() {
  return(
    <div className="hint-overlay-container">
      <div className="hint-overlay-inner">
        <p className="hint-overlay-text">
          Bitte drehe Dein Smartphone, <br/> um die 3D Umgebung nutzen zu können.
        </p>
        <div className="hint-overlay-img-wrap">
          <img src={HintImage} alt={TEXT_HINT}/>
        </div>
      </div>
    </div>
  )
}